import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";
import { SwipeOnboarding } from "@/components/onboarding/SwipeOnboarding";

const Onboarding = () => {
  const [checkingMembership, setCheckingMembership] = useState(true);
  const navigate = useNavigate();

  // Check if user already has an organization
  useEffect(() => {
    const checkExistingMembership = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          navigate("/auth");
          return;
        }

        const { data: membership } = await supabase
          .from("memberships")
          .select("organization_id")
          .eq("user_id", user.id)
          .limit(1)
          .maybeSingle();

        if (membership) {
          // User already has an organization, redirect to feed
          navigate("/app/feed");
          return;
        }
      } catch (error) {
        console.error("Error checking membership:", error);
      } finally {
        setCheckingMembership(false);
      }
    };

    checkExistingMembership();
  }, [navigate]);

  // Show loading state while checking membership
  if (checkingMembership) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return <SwipeOnboarding onComplete={() => navigate("/app/feed")} />;
};

export default Onboarding;
